(() => {
  const el = (tag, cls, text) => {
    const node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const media = (image, fallback, cls) => {
    const box = el('span', cls);
    if (image) {
      const img = el('img');
      img.src = image; img.alt = ''; img.loading = 'lazy'; box.append(img);
    } else box.append(el('span', '', fallback));
    return box;
  };
  const partsLabel = (count) => {
    if (count === undefined || count === null || count === '') return '';
    const number = Number(count);
    if (!Number.isFinite(number)) return '';
    return `${number} Part${number === 1 ? '' : 's'}`;
  };
  const mount = () => {
    const finder = document.querySelector('[data-parts-finder-selector]');
    const target = finder?.querySelector('.htpf-selector');
    const template = document.querySelector('[data-htpf-brand-browser-template]');
    if (!finder || !target || !template) return;
    target.querySelector('[data-htpf-brand-browser]')?.remove();
    target.append(template.content.cloneNode(true));
    const browser = target.querySelector('[data-htpf-brand-browser]');
    const grid = browser.querySelector('[data-htpf-brand-grid]');
    const empty = browser.querySelector('[data-htpf-model-empty]');
    const content = browser.querySelector('[data-htpf-model-content]');
    const brands = [...finder.querySelectorAll('[data-pf-brand-option]')];
    const models = [...finder.querySelectorAll('[data-pf-model-source]')].map(node => ({ ...node.dataset }));
    const buttons = [];
    const open = (handle, scroll = false) => {
      const brand = brands.find(node => node.dataset.brandHandle === handle);
      const list = models.filter(model => model.brandHandle === handle);
      if (!brand || !list.length) return;
      buttons.forEach(button => {
        const active = button.dataset.brandHandle === handle;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      empty.hidden = true; content.hidden = false; content.replaceChildren();
      const header = el('header', 'htpf-model-header');
      const identity = el('div', 'htpf-model-header__identity');
      identity.append(media(brand.dataset.brandImage, brand.dataset.brandTitle.slice(0, 2).toUpperCase(), 'htpf-model-header__logo'));
      const heading = el('div');
      heading.append(el('small', '', browser.dataset.modelHeading || 'Select your model'), el('h4', '', brand.dataset.brandTitle));
      identity.append(heading);
      header.append(identity, el('span', 'htpf-model-count', `${list.length} model${list.length === 1 ? '' : 's'}`));
      const modelGrid = el('div', 'htpf-model-grid');
      list.forEach(model => {
        const card = el('a', 'htpf-model-card');
        card.href = model.modelUrl; card.dataset.htpfModelCard = '';
        const copy = el('span', 'htpf-model-card__copy');
        const meta = [
          model.modelGroup || brand.dataset.brandTitle,
          partsLabel(model.modelCount)
        ].filter(Boolean).join(' · ');
        copy.append(el('strong', '', model.modelTitle), el('small', '', meta));
        const arrow = el('span', 'htpf-model-card__arrow', '→'); arrow.setAttribute('aria-hidden', 'true');
        card.append(media(model.modelImage, model.modelTitle.slice(0, 2).toUpperCase(), 'htpf-model-card__media'), copy, arrow);
        modelGrid.append(card);
      });
      content.append(header, modelGrid);
      if (scroll) {
        setTimeout(() => {
          if (matchMedia('(max-width:749px)').matches) {
            content.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
          }

          const desktopScrollPadding = 120;
          const top = window.scrollY + content.getBoundingClientRect().top - desktopScrollPadding;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        }, 80);
      }
    };
    brands.forEach(brand => {
      const list = models.filter(model => model.brandHandle === brand.dataset.brandHandle);
      if (!list.length) return;
      const button = el('button', 'htpf-brand-tile');
      button.type = 'button'; button.dataset.brandHandle = brand.dataset.brandHandle; button.setAttribute('aria-pressed', 'false');
      const copy = el('span');
      copy.append(el('strong', '', brand.dataset.brandTitle), el('small', '', `${list.length} model${list.length === 1 ? '' : 's'}`));
      button.append(media(brand.dataset.brandImage, brand.dataset.brandTitle.slice(0, 2).toUpperCase(), 'htpf-brand-tile__logo'), copy);
      button.addEventListener('click', () => open(brand.dataset.brandHandle, true));
      grid.append(button); buttons.push(button);
    });
    browser.addEventListener('click', event => event.target.closest('[data-htpf-model-card]')?.classList.add('is-opening'));
    const selected = new URL(location.href).searchParams.get('brand');
    if (selected) open(selected);
  };
  mount();
  document.addEventListener('shopify:section:load', () => setTimeout(mount));
  if (window.__htpfDirectModelNavigation) return;
  window.__htpfDirectModelNavigation = true;
  document.addEventListener('click', event => {
    const option = event.target.closest('[data-parts-finder-selector] [data-pf-model-option]');
    if (!option?.dataset.modelUrl) return;
    event.preventDefault(); event.stopImmediatePropagation(); option.classList.add('is-opening');
    location.assign(option.dataset.modelUrl);
  }, true);
})();
